import { createFileRoute } from '@tanstack/react-router'

import SkillLecturePage from '@/skill/components/SkillLecturePage/SkillLecturePage'

export const Route = createFileRoute(
  '/_learning/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}',
)({
  component: SkillLecturePage,
})
